export default {
  root: {
    padding: 40,
  },
  formContainer: {
    padding: 40,
  },
  thumbnail: {
    width: '100%',
    height: '100%',
  },
}
